import WaterFall2D from '../waterfall2d';
import KagiDataset from '../../dataset/kagi';
import {
  pluckNumber,
  pluck,
  toPrecision
} from '@fusioncharts/core/src/lib';
let UNDEF,
  HUNDREDSTRING = '100',
  SEVENTYSTRING = '70',
  KAGI = 'kagi';

class Kagi extends WaterFall2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Kagi';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Kagi';
  }

  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.singleseries = true;
    config.hasLegend = false;
    config.defaultDatasetType = KAGI;
    config.setAdaptiveMin = true;
    config.anchorborderthickness = 1;
    config.anchorimageurl = UNDEF;
    config.anchorimagepadding = 1;
    config.anchorsides = 1;
    config.anchoralpha = UNDEF;
    config.anchorbgalpha = HUNDREDSTRING;
    config.anchorimagealpha = HUNDREDSTRING;
    config.anchorimagescale = 100;
    config.anchorstartangle = 90;
    config.anchorshadow = 0;
    config.anchorbgcolor = UNDEF;
    config.anchorbordercolor = UNDEF;
    config.anchorradius = 3;
    config.showvalues = 1;
    config.plotfillalpha = SEVENTYSTRING;
    config.linedashlen = 5;
    config.linedashgap = 4;
    config.linedashed = UNDEF;
    config.linealpha = HUNDREDSTRING;
    config.linethickness = 2;
    config.drawfullareaborder = 1;
    config.connectnulldata = 0;
    config.zeroplanethickness = 1;
    config.enablemousetracking = true;
    config.zeroplanealpha = 40;
    config.showzeroplaneontop = 0;
  }

  _getDataset () {
    var dataSetArr = [];

    this.iterateComponents((child) => {
      if ((child.getType && child.getType() === 'dataset')) {
        dataSetArr.push(child);
      }
    });
    return dataSetArr;
  }

  _postSpaceManagement () {
    var iapi = this,
      config = iapi.config,
      xAxis = iapi.getChildren('xAxis')[0],
      yAxis = iapi.getChildren('yAxis')[0],
      canvas = iapi.getChildren('canvas')[0],
      canvasConfig = canvas.config,
      canvasBorderWidth = canvasConfig.canvasBorderWidth,
      canvasPadding = pluckNumber(canvasConfig.canvasPadding, 15),
      canvasPaddingTop = canvasConfig.canvasPaddingTop,
      canvasPaddingBottom = canvasConfig.canvasPaddingBottom, // eslint-disable-line good-practices/no-single-usage-variable
      canvasPaddingLeft = canvasConfig.canvasPaddingLeft, // eslint-disable-line good-practices/no-single-usage-variable
      canvasPaddingRight = canvasConfig.canvasPaddingRight, // eslint-disable-line good-practices/no-single-usage-variable
      chartAttrs = iapi.getFromEnv('dataSource').chart, // eslint-disable-line good-practices/no-single-usage-variable
      series = iapi._getDataset()[0].config,
      shiftCount = series && series.shiftCount,
      min = pluckNumber(xAxis.getAxisConfig('axisMinValue'), 0), // eslint-disable-line good-practices/no-single-usage-variable
      max = pluckNumber(xAxis.getAxisConfig('axisMaxValue'), shiftCount - 1),
      // plot area will not be less then 10 px
      // leftPixelPad = mathMin(pluckNumber(chartAttrs.canvaspadding, 0), (canvasWidth / 2) - 10),
      // rightPixelPad = leftPixelPad,
      // The maximum horizontal shift in percentage of the
      // available canvas width
      maxHShiftPercent = pluckNumber(chartAttrs.maxhshiftpercent, 10),
      effectiveCanvasWidth = iapi.config.canvasWidth - canvasPadding * 2,
      shift = config.shift || 0,
      xShiftLength;

    yAxis && yAxis.setAxisDimention({
      x: yAxis.config.isOpposit
        ? config.canvasRight + canvasBorderWidth : config.canvasLeft - canvasBorderWidth,
      y: config.canvasTop + canvasPaddingTop,
      opposite: yAxis.config.isOpposit
        ? config.canvasLeft - canvasBorderWidth : config.canvasRight + canvasBorderWidth,
      axisLength: config.canvasHeight - canvasPaddingTop - canvasPaddingBottom
    });

    iapi._setPosition();
    if (series) {
      // maxHShiftPercent can not be < 0
      maxHShiftPercent = maxHShiftPercent <= 0
        ? 10 : maxHShiftPercent;
      xShiftLength = series.xShiftLength =
                  Math.min(effectiveCanvasWidth / shiftCount,
                    maxHShiftPercent * effectiveCanvasWidth / 100);
      // leftPixelPad = canvasPadding + xShiftLength / 2;
      // canvasWidth - ((xShiftLength *
      // // handling single value rendering issue in Kagi
      // mathMax((shiftCount - 1), 1)) + leftPixelPad);
      // Fix for Kagi chart single value rendering issue
      // If there is a single value, we use xAxis max value
      // as 1 not as 0
      max = Math.max(max, 1);
    }

    // function for adjusting value padding depending upon data and axis labels.
    canvas.setCanvasPadding();
    xAxis && xAxis.setAxisConfig({
      'canvasPaddingLeft': Math.max(canvasPaddingLeft, canvasPadding) + (xShiftLength / 2),
      'canvasPaddingRight': Math.max(canvasPaddingRight, canvasPadding) + (xShiftLength / 2)
    });
    xAxis && xAxis.setAxisDimention({
      x: iapi.config.canvasLeft + canvasPadding + (xShiftLength / 2),
      axisLength: xShiftLength * (max - min),
      y: xAxis.config.isOpposit
        ? config.canvasTop - canvasBorderWidth
        : config.canvasBottom + shift + canvasBorderWidth,
      opposite: xAxis.config.isOpposit
        ? config.canvasBottom + shift + canvasBorderWidth
        : config.canvasTop - canvasBorderWidth
    });

    iapi.allocateDimensionOfChartMenuBar();
  }

  _setPosition () {
    var i,
      point,
      yValue,
      isRally,
      lastHigh,
      lastLow,
      isRallyInitialised,
      lastPoint,
      iapi = this,
      dataObj = iapi.getFromEnv('dataSource'),
      dataSet = iapi._getDataset()[0],
      categories = dataObj.data || (dataSet && dataSet[0] && dataSet[0].data),
      setDataArr = dataSet.components.data,
      dataSetLen = setDataArr && setDataArr.length,
      yAxis = iapi.getChildren('yAxis')[0],
      xValue = 0,
      plotX = xValue, // eslint-disable-line good-practices/no-single-usage-variable
      catArr = [];
    // create plot elements
    for (i = 0; i < dataSetLen; i++) {
      point = setDataArr[i].config;
      yValue = point.setValue;

      dataObj = setDataArr[i];

      // Creating the data object if not created
      if (!dataObj) {
        dataObj = setDataArr[i] = {
          graphics: {}
        };
      }
      if (!point.isDefined) {
        yValue = point.plotValue;
      }

      // Getting appropiate value for the current plot point.
      yValue = pluck(point.plotValue, yValue);

      // Set the y position.
      point.plotY = toPrecision(yAxis.getPixel(point.setValue), 2);

      // Store value textbox y position.
      point.graphY = yValue && toPrecision(yAxis.getPixel(yValue), 2);

      // Abscissa of the point on the kagi line.
      point.plotX = plotX;
      // If there is a horizontal shift, then abscissa of the kagi
      // line and as such all points on it shifts to the right by a
      // slab more.
      if (point.isShift) {
        xValue += 1;
        plotX = xValue;
        categories && catArr.push(categories[i]);
      } else if (i === (dataSetLen - 1)) {
        categories && catArr.push(categories[i]);
      }

      if (i) {
        lastPoint = setDataArr[i - 1].config;

        // Getting the previously bundled up properties in local
        // variables.
        isRally = point && point.objParams && point.objParams.isRally;
        lastHigh = point && point.objParams && point.objParams.lastHigh;
        lastLow = point && point.objParams && point.objParams.lastLow;
        isRallyInitialised = point && point.objParams &&
                      point.objParams.isRallyInitialised;

        // To find if there is a change in trend towards the current
        // plot.
        if (lastPoint && isRallyInitialised &&
                      lastPoint.isRally !== point.isRally) {
          // Setting in this.data for the plot, to be used for.
          // Setting the color/thickness the graph segments.
          point.isChanged = true;

          // To get the pixel position of the transtion point and
          // storing in data point for the plot.
          point.ty = toPrecision(yAxis.getPixel((isRally
            ? lastHigh : lastLow)), 2);
        } else {
          // Setting in this.data for the plot.
          point.isChanged = false;
        }
      }
    }
    // end of previous translation
  }

  getDSdef () {
    return KagiDataset;
  }
}
export default Kagi;
